import Earnings from '@/services/earnings';

const state = {
    earnings: [],
};

const getters = {
    getEarnings: state => state.earnings,
};

const actions = {
    async fetchEarnings({ commit }) {
        const response = await Earnings.getAll();
        commit('setEarnings', response.data);
    },
};

const mutations = {
    setEarnings: (state, earnings) => (state.earnings = earnings),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
